import { useState } from "react";
import useResizeObserver from "./useResizeObserver";
/**
 * Measures the children's dimensions.
 */
const useRuler = (onChange) => {
    const [rulerRef, setRulerRef] = useState(null);
    const rect = useResizeObserver(rulerRef, onChange);
    return { rect, ref: setRulerRef };
};
export default useRuler;
//# sourceMappingURL=useRuler.js.map